import React, { createContext, useContext, useMemo, useState } from "react";
import { useDefaultTab } from "../hooks/useCompanySettings";

const MainContext = createContext("light");

export default function MainContextProvider({ children }) {
  const [tab, tabSet] = useState({
    currentTab: useDefaultTab(),
    isChangeTab: false,
    tabName: useDefaultTab() === 1 ? "historical-tab" : "share-price-tab",
  });

  const valueMemo = useMemo(() => ({ tab, tabSet }), [tab, tabSet]);

  return <MainContext.Provider value={valueMemo}>{children}</MainContext.Provider>;
}

export const useMainContext = () => {
  return useContext(MainContext);
};
